/**
 * @file privacy-policy.component.ts
 */
import { Component, OnInit, Input } from '@angular/core';
import { MultilingualService } from '@core/services';
import { CMSContent } from '@models/interfaces';
import { AppCenterAnalytics, AppInsightsService, CmsService } from '@shared/services';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: [],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  @Input() isOpenedFromGuest!: boolean;

  privacyPolicy!: CMSContent;
  isLoading = false;
  isError = false;
  errMsg!: string;

  constructor(
    private readonly cmsService: CmsService,
    private readonly appInsightsService: AppInsightsService,
    public readonly multilingualService: MultilingualService,
  ) { }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.PRIVACY_POLICY_VIEWED);
    this.isLoading = true;
    this.isError = false;
    this.cmsService.getPrivacyPolicy().subscribe((res) => {
      this.privacyPolicy = res;
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
      this.isError = true;
      this.errMsg = err;
    });
  }
}
